import { useEffect, useRef, useState } from "react";
import "./VisionMision.css";

const VisionMision = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 👇 entra
        if (entry.isIntersecting) {
          setVisible(true);
        } 
        // 👇 sale → reinicia
        else {
          setVisible(false);
        }
      },
      {
        threshold: 0.3, // porcentaje visible para activar
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className={`container my-5 vision-mision ${visible ? "animate" : ""}`}
    >
      <div className="row text-uppercase d-flex align-items-center">
        <div className="col-md-6 text-end mision fade-left">
          <h1>Misión</h1>
          <p>
            Brindar soluciones visuales mediante evaluaciones precisas,
            diagnósticos oportunos y ayudas ópticas de alta calidad, así como
            promover la salud integral de cada persona mediante un enfoque
            preventivo y un servicio profesional en todo el estado.
          </p>
        </div>

        <div className="col-md-6 text-center zoom">
          <img src="/img/mision.png" alt="" width="300" />
        </div>

        <div className="col-md-6 text-center zoom">
          <img src="/img/vision.png" alt="" width="300" />
        </div>

        <div className="col-md-6 mision fade-right">
          <h1>Visión</h1>
          <p>
            Ser una empresa líder en el mercado óptico en la región, reconocida
            por impulsar la salud visual e integral mediante precisión,
            tecnología y una experiencia humana que inspira confianza y promueve
            la prevención.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VisionMision;
